import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs/Observable";
import {MainTGiftVoucherTransfer} from "../model/t-gift-voucher-transfer";
import {AppSettings} from '../../../settings/app-settings';

@Injectable()
export class TGiftVoucherTransferService {

  constructor(private http: HttpClient) {
  }

  public findByTransactionNumber(tNumber: number): Observable<MainTGiftVoucherTransfer> {
    return this.http.get<MainTGiftVoucherTransfer>(AppSettings.API_ENDPOINT + "/api/v1/gflock-main-service/trasactions/gift-vouchers/find-by-t-number/" + tNumber);
  }

  public save(tGiftVoucherTransfer: MainTGiftVoucherTransfer): Observable<MainTGiftVoucherTransfer> {
    return this.http.post<MainTGiftVoucherTransfer>(AppSettings.API_ENDPOINT + "/api/v1/gflock-main-service/trasactions/gift-vouchers/save", tGiftVoucherTransfer);
  }
}



// WEBPACK FOOTER //
// ./src/app/view/transactions/t-gift-voucher-transfer/service/t-gift-voucher-transfer.service.ts